import { Component, inject, Inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';

import { ListDto } from '../../clinical-care/core/models/dtos/PendentDto';
import { OrderService } from '../../clinical-care/core/services/api/order.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { OrderDetailComponent } from '../../clinical-care/views/order/order-detail/order-detail.component';

@Component({
    selector: 'app-tableloans',
    imports: [TableModule, ButtonModule, RippleModule, TagModule],
    templateUrl: './tableloans.component.html',
    styleUrl: './tableloans.component.scss',
    providers: [DialogService]
})
export class TableloansComponent {
    private _orderService = inject(OrderService);
    filteredOrders: ListDto[] = [];
    listOrder: ListDto[] = [];
    pendingOrders: ListDto[] = [];

    statusOrderList: Array<{ id: number; code: string }> = [];
    statusOrderMap: { [id: number]: string } = {};

    searchOrder: string = '';

    filterStartDate: Date | null = null;
    filterEndDate: Date | null = null;

    constructor(private _dialogService: DialogService) {}

    ngOnInit() {
        this._orderService.getstatuscab().subscribe({
            next: (result) => {
                if (result && Array.isArray(result.data)) {
                    this.statusOrderMap = {};
                    this.statusOrderList = result.data.map((item: any) => {
                        this.statusOrderMap[item.idStatus] = item.code;
                        return { id: item.idStatus, code: item.code };
                    });
                }
            },
            error: (err) => {
                console.error('Error al cargar status ORDER', err);
            }
        });
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth()).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        this.filterStartDate = new Date(Number(yyyy), Number(mm), Number(dd));
        this.filterEndDate = new Date(Number(yyyy), Number(mm), Number(dd));
        this.onSearchOrdersDate();
    }

    // #region Métodos existentes (sin cambios)
    onSearchOrdersDate() {
        if (!this.filterStartDate || !this.filterEndDate) {
            this.filteredOrders = [...this.listOrder];
            return;
        }

        const startDate = new Date(this.filterStartDate);
        const endDate = new Date(this.filterEndDate);

        const format = (d: Date) => d.toISOString().slice(0, 10);

        const from = format(startDate);
        const to = format(endDate);

        this._orderService.SearchOrdersList('date', undefined, from, to).subscribe({
            next: (res) => {
                const allOrders = res.data || [];
                this.filteredOrders = allOrders;
                this.pendingOrders = allOrders.filter(o =>
                    (o.orderDetail || []).some(d => (d.fileCount ?? 0) === 0)
                );
            },
            error: () => {
                this.filteredOrders = [];
                this.pendingOrders = [];
            }
        });
    }

    getOrderStatusCodeById(id: number): string {
        return this.statusOrderMap[id] || '';
    }

    openOrderDetail(order: ListDto): void {
        const ref: DynamicDialogRef | null = this._dialogService.open(OrderDetailComponent, {
            header: `Detalle de Orden: ${order.codOrder}`,
            width: '60vw',
            height: 'auto',
            contentStyle: { overflow: 'auto' },
            baseZIndex: 10000,
            maximizable: false,
            closable: true,
            data: {
                idOrder: order.idOrder
            }
        });
    }
}
